import { render, staticRenderFns } from "./ChatHeader.vue?vue&type=template&id=35a53908&"
import script from "./ChatHeader.vue?vue&type=script&setup=true&lang=js&"
export * from "./ChatHeader.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports